export const isFunction = (obj: any): obj is Function =>
  typeof obj === 'function';
